import {
  RxFormsBrowserComponent,
  RxReactiveFormCompositeComponent,
  RxTextCompositeComponent,
} from '@nrwl/rx-forms';

import { DialogsConfigService } from '../dialogs-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Validators } from '@angular/forms';
import { rxRequiredValidator } from '@nrwl/rx-validators';
import { RxCookieConsentComponent } from 'libs/rx-components/src/lib/rx-cookie-consent/rx-cookie-consent.component';

@Injectable({
  providedIn: 'root',
})
export class ClientsListDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public FillSign() {
    return {
      component: RxFormsBrowserComponent,
      payload: {
        title: 'Select',
        buttons: this.SubmitDismissButtons('Select'),
      },
    };
  }

  public AlertMarkAllAsReadConfirm() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Warning',
        tip: `Please note that all notifications regarding messages and events will be marked as read.`,
        buttons: this.SubmitButton('OK'),
      },
    };
  }

  // public createClient() {
  //     return {
  //         hideFooter: true,
  //         component: RxReactiveFormCompositeComponent,
  //         payload: {
  //             title: 'Create Client',
  //             tip: 'Please complete the required fields below to add a new client',
  //             tipClose: false,
  //         },
  //     };
  // }

  public userExistsNotification(data: any) {
    return {
      hideFooter: true,
      payload: {
        title: 'Already Exists',
        data,
      },
    };
  }

  public emrRestriction() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'EMR Restriction',
        tip: `You are accessing your account through an integrated partner. Importing and creating new clients is disabled. Please contact <a href="mailto:support@rxphoto.com">support@rxphoto.com</a> for further assistance.`,
        buttons: this.DismissButton('OK'),
      },
    };
  }

  public archiveConfirm() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Client archiving',
        tip: 'Are you sure you want to archive this Client?',
        tipClose: false,
        buttons: this.SubmitDismissButtons('Confirm', 'Cancel'),
      },
    };
  }

  public restoreConfirm() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Client unarchiving',
        tip: 'Are you sure you want to restore this Client?',
        tipClose: false,
        buttons: this.SubmitDismissButtons('Confirm', 'Cancel'),
      },
    };
  }

  public mergeDublicateClients() {
    return {
      width: '600px',
      panelClass: 'merge-clients-dialog',
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'Please Select Primary Client Record',
        tipClose: false,
        buttons: this.DismissCustomButtons('Dismiss', 'Done', true),
      },
    };
  }

  public mergeInProgress() {
    return {
      component: RxTextCompositeComponent,
      panelClass: 'merge-in-progress-dialog',
      payload: {
        title: 'Merge is in progress',
        tip: 'We are merging the duplicate clients into the primary client. All duplicate clients will be viewable in the archived folder.<br/><br/>You will receive a notification once the merge is complete. Please feel free to navigate away and continue working; there is no need to wait on the client list.',
        tipClose: false,
        buttons: this.DismissButton('Okay'),
      },
    };
  }

  public selectClientsForMerging() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Select Clients',
        tip: 'Select at least 2 clients to use this tool.',
        tipClose: false,
        buttons: this.DismissButton(),
      },
    };
  }

  public deselectClientsForMerging() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Deselect Clients',
        tip: 'All selected clients will be deselected by this action.',
        tipClose: false,
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public emrRestrictionForMerging() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'EMR Restriction',
        tip: 'You are accessing your account through an integrated partner. Please merge clients in your integrated partner application.',
        tipClose: false,
        buttons: this.DismissButton(),
      },
    };
  }

  public WarningPermissionEmployee() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'You must have Manager or Administrator permission status to access these areas. If you are seeing this message and feel you should have access, please contact with your administrator and request change in permissions. ',
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public WarningMergePermissionManager() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'Administrator permissions are needed to merge more than 2 client profiles.',
        buttons: this.SubmitButton('OK'),
      },
    };
  }

  public emrRestrictionForCreating() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'EMR Restriction',
        tip: 'You are accessing your account through an integrated partner. Please use the search field to retrieve clients.',
        tipClose: false,
        buttons: this.DismissButton('OK'),
      },
    };
  }

  public messageContextAlert() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Messages',
        tip: `To access received messages, please sign in to the RxPhoto mobile app and follow the steps below:<br />
                <img src="assets/images/message_instruction.jpeg" style="margin: 0 auto; width: 100%">`,
        buttons: this.SubmitButton('I Understand'),
      },
    };
  }

  public mergeConfirmation(amount: number, value: string) {
    const regexp = new RegExp(`^(\\s*)(${value}{1})(\\s*)$`, 'i');
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: `Merge ${amount} Duplicates`,
        tipClose: false,
        tip: 'Type first name of the primary account to confirm merging',
        hasInlineInfo: true,
        fields: [
          {
            placeholder: 'First Name',
            maxLength: 50,
            labelText: 'Type first name of the primary account to confirm merging',
            hasInlineInfo: true,
            customErrors: {
              pattern: "Primary client’s first name doesn't match",
            },
            validators: [rxRequiredValidator, Validators.maxLength(50), Validators.pattern(regexp)],
          },
        ],
        buttons: this.SubmitDismissButtons('Merge', 'Cancel'),
      },
    };
  }

  public incorrectEMRIntegration() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Clinic EMR Integration',
        tip: `Your RxPhoto account is integrated with a 3rd Party Service Provider. Please click on EMR and select your integrated partner to log into the RxPhoto website.`,
        buttons: this.SubmitButton('I Understand'),
      },
    };
  }

  public showCookieConsentBox() {
    return {
      component: RxCookieConsentComponent,
      payload: {
        title: 'Manage Cookie Consent',
        text: 'To provide the best experiences, we use technologies like cookies to store and/or access device information. Consenting to these technologies will allow us to process data such as browsing behavior or unique IDs on this site. Not consenting or withdrawing consent, may adversely affect certain features and functions.',
        buttons: {
          accept: {
            text: 'Accept',
          },
          deny: {
            text: 'Deny',
          },
          preferences: {
            text: 'View prefences',
          },
        },
      },
      position: { left: '2rem', bottom: '2rem' },
      hasBackdrop: false,
      headerClasses: 'consent',
      hideDialogClose: true,
      hideFooter: true,
      panelClass: 'consent',
    };
  }

  public blockMergeWhileSearchingClients(emrName: string) {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Merge Restriction',
        tip: `Merging clients is not available when ${emrName} is selected as the search module. Please manually add selected clients to RxPhoto from your integration partner before attempting to merge them.`,
        buttons: this.DismissButton('OK'),
      },
    };
  }
}
